import moment from 'moment';
import { CommonGet, CommonPost } from '../../helpers/HttpClient';
import tokenDecoder from '../../utils/tokenDecoder';

export default {
  getAllGroups,
  getAllFactoriesByGroupID,
  GetCollectionTypeAdvanceRateDetails,
  GetSupplierRateConfigurationDetails,
  SaveSupplierRateConfigurationDetails,
  getRoutesForDropDown,
  CheckBalancePaymentHasOccured,
  GetTransactionTypesForSupplierRateConfiguration
};

async function getAllGroups() {
  let response = await CommonGet('/api/Factory/GetAllActiveGroups', null);
  let groupArray = []
  for (let item of Object.entries(response.data)) {
    groupArray[item[1]["groupID"]] = item[1]["groupName"]
  }
  return groupArray;
}

async function getAllFactoriesByGroupID(groupID) {
  let response = await CommonGet('/api/Factory/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID));
  let factoryArray = []
  for (let item of Object.entries(response.data)) {
    factoryArray[item[1]["factoryID"]] = item[1]["factoryName"]
  }
  return factoryArray;
}

async function GetCollectionTypeAdvanceRateDetails(factoryID, productID, date) {
  var month = moment(date).format('MM');
  var year = moment(date).format('YYYY');

  const response = await CommonGet('/api/CollectionTypeAdvanceRate/GetCollectionTypeAdvanceRateDetails',
    "factoryID=" + parseInt(factoryID) + "&productID=" + parseInt(productID)
    + "&applicableMonth=" + month + "&applicableYear=" + year);

  return response.data;
}

async function GetSupplierRateConfigurationDetails(groupID, factoryID, routeID, transactionTypeID, transactionTypeCode, date, registrationNumber) {

  var month = moment(date).format('MM');
  var year = moment(date).format('YYYY');

  const response = await CommonGet('/api/SupplierRateConfiguration/GetSupplierRateConfigurationDetails',
    "groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID) + "&routeID=" + parseInt(routeID) 
    + "&applicableMonth=" + month + "&applicableYear=" + year + "&transactionTypeID=" + parseInt(transactionTypeID)+ "&transactionTypeCode=" + transactionTypeCode + "&registrationNumber=" + registrationNumber );
  return response.data;
}

async function SaveSupplierRateConfigurationDetails(data) {
  const response = await CommonPost('/api/SupplierRateConfiguration/SaveSupplierRateConfigurationDetails', null, data);
  return response;
}

async function getRoutesForDropDown(factoryID) {
  var routeArray = [];

  const response = await CommonGet('/api/Group/GetRouteByFactoryID', 'factoryID=' + factoryID)
  for (let item of Object.entries(response.data)) {
    routeArray[item[1]["routeID"]] = item[1]["routeName"]
  }
  return routeArray;
}

async function CheckBalancePaymentHasOccured(groupID, factoryID, date) {

  var month = moment(date).format('MM');
  var year = moment(date).format('YYYY');

  const response = await CommonGet('/api/SupplierRateConfiguration/CheckBalancePaymentHasOccured',
    "groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID)
    + "&applicableMonth=" + month + "&applicableYear=" + year );
  return response;
}

async function GetTransactionTypesForSupplierRateConfiguration() {
  let response = await CommonGet('/api/SupplierRateConfiguration/GetTransactionTypesForSupplierRateConfiguration', null);
  let groupArray = []
  for (let item of Object.entries(response.data)) {
    groupArray[item[1]["transactionTypeID"]] = { name: item[1]["transactionTypeName"], code: item[1]["transactionTypeCode"] }
  }
  return groupArray;
}
